import { Box } from "@mui/material";

const withFullScreen = (component: JSX.Element): JSX.Element => (
  <Box sx={{ height: "70vh", justifyContent: "center", display: "flex" }}>
    {component}
  </Box>
);

export default withFullScreen;
